module.exports = __webpack_public_path__ + "static/media/icon-kitten-title-right.31fba653.svg";